<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Configurations</div>
                </div>
            </div>
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="configurations.columns" :data="configurations.data">
                    <template slot="table-row" v-if="configurations.data.length">
                        <tr v-for="(item, index) in configurations.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.key}}</td>
                            <td v-if="item.value.length > 1">{{item.value}}</td>
                            <td v-else-if="item.value == 1"><i class="fa fa-check"></i></td>
                            <td v-else-if="item.value == 0"><i class="fa fa-close"></i></td>
                            <td>
                                <div class="btn-group" role="group">
                                  <button class="btn btn-info btn-sm" @click="editConfiguration(item)" v-tooltip.top-center="configurations.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const configurationColumns = ['Key', 'Value', 'Operations'];
    export default {
        name: 'configurations',
        components: {
            LTable,
        },
        data() {
        return {
          configurations: {
                tooltips: {
                    edit: 'Edit Configuration'
                },
                columns: [...configurationColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchConfigurations () {
            this.$store.dispatch('FETCH_CONFIGURATIONS')
                    .then((res) => {
                        console.log(res)
                        this.configurations.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
      editConfiguration(item){
        let type = 'text', checked = false;
        let itemValue = item.value.trim();
        console.log('item value original', item.value.length)
        console.log('item value', itemValue.length)
        let len = itemValue ? itemValue.length : 0;
        console.log('item value', itemValue)
        if (itemValue && (itemValue === '1' || itemValue === '0')) {
          console.info('inside checkbox')
          type = 'checkbox';
          item.value == 1 && (checked = true);
        } else {
          console.info('inside text')
          type = 'text'
        }
        // if(len <= 1){
        //   type = 'checkbox';
        //   item.value == 1 && (checked = true);
        // }
        let swal = this.$swal;
        let _self = this;
        (async function getFormValues () {
          let input = checked ? `<input id="swal-input1" type=${type} checked=${checked} value=${itemValue} class="swal2-input" disabled>` :
            `<input id="swal-input1" type="${type}" value="${itemValue}" class="swal2-input" disabled>`;
          console.log('input to display', input)
          const {value: formValues} = await swal({
            title: item.key,
            html:
            '<div class="sub-heading">Previous Value</div>' +
             input +
            `<input id="swal-input2" type=${type} class="swal2-input">`,
            focusConfirm: false,
            width:'60%',
            preConfirm: () => {
//              value = type = 'text' ?
              let value = type === 'text' ? document.getElementById('swal-input2').value :
                document.getElementById('swal-input2').checked ? "1" : "0";
              return value
            },
            showCancelButton: true
          });

          if (!formValues) {
            return false;
          }
          else if(formValues === true){
            _self.showPopup('Error!', 'Please Enter New Value', 'error')
          }
          else{
            let update = {
              "appconfiguration_id": item.appconfiguration_id,
              "value": formValues
            };
            _self.$store.dispatch('UPDATE_CONFIGURATION', update)
              .then((res) => {
                console.log("UPDATE_CONFIGURATION res : ", res);
                _self.fetchConfigurations();
                _self.showPopup('Success!', 'Configuration is successfully updated', 'success')

              })
              .catch(err => {
                _self.showPopup('Error!', 'some thing happen wrong', 'error');
                console.log("UPDATE_CONFIGURATION API error : ", err);
              })
          }
        })()
      },
      showPopup(title, msg, popupType, cb){
        this.$swal( title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      }
    },
    created() {
        this.fetchConfigurations();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
    .sub-heading{
      margin-top: 30px;
      margin-bottom: -12px
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Configurations/Configurations.vue